import script from "./UserPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./UserPanel.vue?vue&type=script&setup=true&lang=js"

import "./UserPanel.vue?vue&type=style&index=0&id=21804947&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21804947"]])

export default __exports__